import React, { useEffect } from "react";


export const BarProgress = (props) => {
    const { trgtBurn, burning, trgtTake, taking } = props;

    useEffect(() => {
        // 바 게이지 계산 필요
    }, []);

    return (
        <div className="progress-bar">
            <div>
                <u>운동</u>

                <div className="bar gr">
                    <span style={{ width: "40%" }}><i>{burning}</i></span>
                </div>
                <div className="under-info">
                    <span>소모칼로리</span> <em>{trgtBurn}kcal</em>
                </div>

            </div>
            <div>
                <u>음식</u>

                <div className="bar bl">
                    <span style={{ width: "60%" }}><i>{taking}</i></span>
                </div>
                <div className="under-info">
                    <span>섭취칼로리</span> <em>{trgtTake}kcal</em>
                </div>


            </div>
        </div>
    );
};
